// src/utils/vendorUtils.js
import api from "core/interceptors/api";

export const fetchVendorProfile = (userEmail, callback) => {
    api
        .get(`/vendor_register/fetch_approved_by_email?email=${userEmail}`)
        .then((response) => {
            const vendor = response.data.vendor;
            if (vendor) {
                callback({
                    businessName: vendor.business_name || "",
                    ownerName: vendor.owner_name || "",
                    email: vendor.email || "",
                    businessType: vendor.business_type || "",
                    mobileNumber: vendor.mobile_number || "",
                    accountNo: vendor.account_number || "",
                    ifscCode: vendor.ifsc_code || "",
                    passbookName: vendor.passbook_name || "",
                    aadharNumber: vendor.aadhar_number || "",
                    panCardNumber: vendor.pan_card_number || "",
                    gst: vendor.gst || "",
                    logo: vendor.logo || null,
                    signaturePhoto: vendor.signature_photo || null,
                    gpay: vendor.gpay || "",
                    phonepe: vendor.phonepe || "",
                    paytm: vendor.paytm || "",
                    upiId: vendor.upi_id || "",
                    alternativeMobileNumber: vendor.alternative_number || "",
                    currentLocation: vendor.current_location || "",
                    keywords: vendor.keywords || "",
                    latitude: vendor.latitude || "",
                    longitude: vendor.longitude || "",
                    branchName: vendor.branch_name || "",
                    bankName: vendor.bank_name || "",
                    vendorPhoto: vendor.vendor_photo || null,
                    shopPhoto: vendor.shop_photo || null,
                    sgoGpsPhoto: vendor.sgo_gps_photo || null,
                    qrCode: vendor.qr_code || null,
                    msmCertificate: vendor.msm_certificate || null,
                    description: vendor.description || "",
                    approvedStatus: vendor.approved_status || "",
                    status: vendor.status || "",
                    reasonForNotApproved: vendor.reason_for_not_approved || "",
                    businessCategory: vendor.business_category || "",
                    userProofDoc: Array.isArray(vendor.user_proof_doc)
                        ? vendor.user_proof_doc.filter(Boolean)
                        : vendor.user_proof_doc
                            ? vendor.user_proof_doc.split(",").filter(Boolean)
                            : [],
                });
            }
        })
        .catch((error) => {
            console.error("Error fetching vendor profile:", error);
        });
};
